<template>
    <div>
        <h1 class="w-full p-2 bg-aitems-700 text-gray-100 font-light tracking-wide">
            {{ trans.get('production.op_in_list' )}}
        </h1>

        <div class="flex w-full p-4 justify-end" v-show="upload">
            <open-modal modal="add-instruction">
                {{ trans.get('production.add_new' )}}
            </open-modal>
        </div>

        <div v-if="instructions.length === 0">
            {{ trans.get('production.no_opin') }}
        </div>

        <ais-instant-search class="flex flex-col mx-auto w-11/12 lg:w-3/4 mt-8" :search-client="searchClient" :index-name="index">
            <div class="flex w-full shadow-md p-4">
                <ais-sort-by class="w-1/6 mr-2 lg:mr-4" :items="[
                    {value: 'instructions', label: 'Nessun ordinamento'},
                    {value: 'instructions_data_creazione_asc', label:'Data Crescente'},
                    {value:'instructions_data_creazione_desc',label:'Data Decrescente'},
                    {value:'instructions_codice_desc',label:'Codice Decrescente'},
                    {value:'instructions_codice_asc',label:'Codice Crescente'},
                ]"
                />
                <ais-search-box class="w-full" :placeholder="'Search here!'" ></ais-search-box>
            </div>
            <div class="flex w-full justify-center">
                <div class="flex flex-col w-1/2 md:w-1/5 mt-10 mr-4 lg:mr-10 text-lg">
                    <div class="flex flex-col shadow-md p-2 lg:p-6">
                        <label class="font-bold uppercase text-gray-700 text-sm pb-3">FILTRO PER REPARTI</label>
                        <ais-refinement-list class="w-full mb-8" attribute="work_unit.descrizione"></ais-refinement-list>
                    </div>
                    <div class="flex flex-col shadow-md p-2 lg:p-6 mt-6">
                        <label class="font-bold uppercase text-gray-700 text-sm pb-3 flex-wrap">FILTRO PER MODIFICHE TECNICHE</label>
                        <ais-refinement-list attribute="tags_mod_tech"/>
                    </div>
                    <div class="flex flex-col shadow-md p-2 lg:p-6 mt-6">
                        <label class="font-bold uppercase text-gray-700 text-sm pb-3 flex-wrap">FILTRO PER PROGETTI COLLEGATI</label>
                        <ais-refinement-list attribute="tags_pr"/>
                    </div>
                </div>
                <ais-hits class="w-full">
                    <div slot-scope="{ items }" class="w-full table mx-auto rounded border shadow-lg mt-10">
                        <div class="flex row" v-for="instruction in items" :key="instruction.objectID">
                            <div class="td flex flex-col whitespace-normal">
                                <div class="uppercase cursor-pointer text-2xl font-bold text-gray-700 font-sans w-full text-left">
                                    <button @click="showInstruction(instruction)">
                                    {{ instruction.codice }}
                                    </button>
                                </div>
                                <div class="flex flex-row font-thin text-gray-600 w-full text-left">
                                    <div class="pr-2">
                                    <span>
                                        {{ instruction.data_immissione | reverseDate }}
                                    </span>
                                    </div>
                                    <div>
                                        - Rev. {{ instruction.revisione }}
                                    </div>
                                </div>
                            </div>
                            <div class="td flex flex-col whitespace-normal">
                                <div class="uppercase text-lg text-gray-700 mb-2 font-semibold w-full text-left">
                                   {{ instruction.work_unit.descrizione }}
                                </div>
                                <div class="w-full text-left">
                                <span class="tag"
                                      v-for="(reparto, instruction) in JSON.parse(instruction.reparti_interessati.replace(/#/g,''))"
                                >
                                     {{reparto}}
                                </span>
                                    <div/>
                                </div>
                            </div>
                            <div class="td flex flex-col whitespace-normal">
                                <div class="uppercase text-lg text-gray-700 mb-2 font-semibold w-full text-left">
                                    {{ instruction.titolo }}
                                </div>
                                <div class="font-thin text-gray-600 w-full text-left">
                                    {{ instruction.descrizione }}
                                </div>
                            </div>
                            <div class="td flex flex-row w-full">
                                <div class="w-1/3 text-right mr-4">
                                    <a :href="instruction.url" target="_blank"
                                       class="hover:text-blue-500">
                                        <i class="far fa-file-pdf fa-3x"
                                        >
                                        </i>
                                    </a>
                                </div>
                                <div class="w-1/3 text-center">
                                    <a :href="instruction.url_video" target="_blank"
                                       class="hover:text-blue-500">
                                        <div v-show="instruction.url_video">
                                            <svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="youtube" class="svg-inline--fa fa-youtube fa-3x" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"></path></svg>
                                        </div>
                                    </a>
                                </div>
                                <div>
                                    <button href="javascript:;" @click="deleteInstruction(instruction)" v-show="delete_iop"
                                            class="w-1/3 px-4 hover:text-blue-500 text-gray-800">
                                        <i class="fas fa-trash-alt fa-2x"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </ais-hits>
            </div>
            <ais-pagination class="my-4 ml-40"/>
        </ais-instant-search>

        <modal name="add-instruction"
               height="auto"
               transition="slide"
               width="650"
        >
            <div class="flex flex-col">

                <div class="w-full flex justify-between items-center py-3 px-1 bg-aitems-700 text-gray-100 mb-6">
                    <div class="font-bold tracking-wide p-2 pl-6 uppercase">Add New Instruction</div>
                    <div class="font-bold p-2 cursor-pointer"
                         @click="$modal.hide('add-instruction')">
                        <i class="fas fa-times-circle"></i>
                    </div>
                </div>
            </div>

            <instruction-creator @instruction-created="OnInstructionHasBeenCreated"></instruction-creator>

        </modal>

        <modal name="show-instruction"
               transition="slide"
               height="auto"
               width="650"
        >
            <div class="flex flex-col">
                <div class="w-full flex justify-between items-center py-3 px-1 bg-aitems-700 text-gray-100 mb-6">
                    <div class="font-bold tracking-wide p-2 pl-6 uppercase">
                        Instruction {{currentInstruction.codice}}
                    </div>
                    <div class="font-bold p-2 cursor-pointer"
                         @click="$modal.hide('show-instruction')">
                        <i class="fas fa-times-circle"></i>
                    </div>
                </div>
            </div>

            <show-instruction :instruction="currentInstruction"></show-instruction>

        </modal>
    </div>
</template>

<script>
    import OpenModal from "./buttons/openModal";
    import InstructionCreator from "./InstructionCreator";
    import Paginate from "./utilities/Paginate";
    import Searchable from "../mixins/Searchable";
    import ShowInstruction from "./ShowInstruction";

    export default {
        mixins: [Searchable],
        name: "InstructionList",

        components: {
            OpenModal,
            InstructionCreator,
            Paginate,
            ShowInstruction,
        },

        props: [
            'instruction',
            'upload',
            'delete_iop'
        ],

        data() {
            return {
                instructions: this.instruction,
                pagination: {},
                index:process.env.MIX_INSTRUCTIONS_INDEX,
                'currentInstruction': {},
            }
        },

        filters: {
            reverseDate(date) {
                if (date != null) {
                    return date.split('-').reverse().join('/');
                }
            },
        },

        created() {
            this.filter();
        },

        methods: {
            OnInstructionHasBeenCreated(instruction) {
                this.instructions.push(instruction);
                this.$modal.hide('add-instruction');
            },

            filter(changed = false) {
                let current_page;

                if (!changed) {
                    current_page = this.pagination.current_page;
                }

                let pageNum = current_page ? current_page : 1;

                axios.get(`/instructions/?paginate=10&page=${pageNum}`)
                    .then(({data}) => {
                        this.instructions = data.data.instructions;
                        this.pagination = data.data.pagination;
                    });
            },

            deleteInstruction(instruction) {
                swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    cancelButtonColor: '#B82266',
                    confirmButtonText: 'Yes, delete it!',
                }).then((result) => {
                    if (result.value) {
                        axios.delete(`/instructions/` + instruction.id)
                            .then(() => {

                                const index = this.instructions.indexOf(instruction);
                                this.instructions.splice(index, 1);

                                swal.fire(
                                    'Deleted!',
                                    'The instruction has been deleted.',
                                    'success'
                                );
                            })
                            .catch(error => {
                                console.log(error)
                            })
                    }
                })
            },

            transformModel(items) {
                return items.map(item => ({
                    ...item,
                    label: JSON.parse(item.label.replace(/#/g,''))
                }))
            },

            showInstruction(instruction) {
                this.currentInstruction = instruction;
                this.$modal.show('show-instruction');
            }
        },
    }


</script>

<style lang="scss" scoped>

    .tag {

        @apply .bg-blue-500 .text-white .tracking-wide .uppercase .rounded .border-0 .p-1 .mr-1;

    }

</style>